import { render, staticRenderFns } from "./SidebarLayout.vue?vue&type=template&id=5664a535"
import script from "./SidebarLayout.vue?vue&type=script&lang=js"
export * from "./SidebarLayout.vue?vue&type=script&lang=js"
import style0 from "./SidebarLayout.vue?vue&type=style&index=0&id=5664a535&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports